import { useState } from 'react';
import { useNavigate } from 'react-router-dom';

import { UserData } from '@/shared/types/UserData';
import { useErrorHandler } from '@/shared/hooks/useErrorHandler';

import { useAlertContext } from '@/contexts/alert.context';
import { bankUserService } from '@/services/bankUser.service';
import { cleanPhoneNumber } from '@/shared/utils/phoneHelpers';

export type CreateBankUserData = UserData & {
  roles: string[];
  inspectionTypes: string[];
};

export function useBankUserRegister() {
  const navigation = useNavigate();

  const { notify } = useAlertContext();
  const { handleError } = useErrorHandler();
  const [isSubmitting, setIsSubmitting] = useState(false);

  const onSubmit = async (data: CreateBankUserData) => {
    setIsSubmitting(true);
    try {
      const cleanPhone = cleanPhoneNumber(data.phone);

      await bankUserService.createBankUser({
        name: data.name,
        email: data.email,
        roleIds: data.roles,
        phoneNumber: cleanPhone,
        inspectionTypeIds: data.inspectionTypes,
      });

      notify({ message: 'Usuario criado com sucesso!', type: 'success' });

      navigation('/bank-list');
    } catch (error) {
      handleError(error);
    } finally {
      setIsSubmitting(false);
    }
  };

  return {
    onSubmit,
    isSubmitting,
  };
}
